if (!customElements.get("carousel-component")) {
    class Carousel extends HTMLElement {
        constructor() {
            super();
            this.carouselElement = this;  
            this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
            this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
            this.focus = this.carouselElement.dataset['focus'];
            this.type = this.carouselElement.dataset['type'];
            this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
            this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
            this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
            this.direction = this.carouselElement.dataset['direction'] || 'ltr';
            this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
            this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
            this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
            this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';

            this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
            this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
            this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
            this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
            this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
            this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
            this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
            this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
            this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
            this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;

            this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
            this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;

            if (!this.carouselElement.classList.contains('splide')) return;

            this.initCarousel();
        }

        initCarousel() {
            if (this.destroyOnMobile && this.destroyOnDesktop) return;
            this.carousel = new Splide(this.carouselElement, {
                perPage: this.desktopPerPage,
                ...(this.type ? { type: this.type } : {}),
                ...(this.focus ? { focus: this.focus } : {}),
                autoplay: this.autoplay,
                interval: this.autoplaySpeed,
                gap: this.gap,
                arrows: this.showarrows,
                pagination: this.showdots,
                isNavigation: this.isNavigation,
                drag: !this.disableDrag,
                direction: this.direction,
                destroy: this.destroyOnDesktop,
                padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
                omitEnd: this.omitEnd,
                breakpoints: {
                    750: {
                        padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
                        perPage: this.mobilePerPage,
                        arrows: this.showarrowsonmobile,
                        pagination: this.showdotsonmobile,
                        gap: this.gapMobile,
                        destroy: this.destroyOnMobile,
                    }
                },
            });

            if (this.sync) {
                this.initCarouselSync()
            } else {
                this.initProgressBar(this.carousel);
                this.carousel.mount();

                this.updateSlideCount(this.carousel);
                this.carousel.on('moved', () => this.updateSlideCount(this.carousel));

                if (this.refresh)
                    this.carousel.refresh()
            }
        }

        updateSlideCount(carousel) {
            const slideCountElement = this.querySelector('.splide__slide-count');
            if (!slideCountElement) return;

            const totalSlides = carousel.Components.Elements.slides.length;
            const currentSlide = carousel.index + 1;

            slideCountElement.textContent = `${currentSlide}/${totalSlides}`;
        }

        initProgressBar(skeletonSplide) {
            const bar = this.querySelector('.my-slider-progress-bar');

            if (!bar) return;

            this.carousel.on('mounted move', function () {
                var end = skeletonSplide.Components.Controller.getEnd() + 1;
                var rate = Math.min((skeletonSplide.index + 1) / end, 1);
                bar.style.width = String(100 * rate) + '%';
            });
        }

        initCarouselSync() {
            this.syncElement = document.querySelector(this.sync);
            this.direction = this.syncElement.dataset['direction'] || 'ltr'

            this.carouselSync = new Splide(this.sync, {
                updateOnMove: true,
                perPage: this.syncElement.dataset['desktopperpage'] || 5,
                type: this.syncElement.dataset['type'] || 'loop',
                focus: this.syncElement.dataset['focus'] || 'center',
                isNavigation: true,
                autoplay: this.syncElement.dataset['autoplay'] === 'true' || false,
                interval: parseInt(this.syncElement.dataset['autoplaySpeed']) || 3000,
                gap: this.syncElement.dataset['gapbetweenslides'] || 0,
                arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
                pagination: this.syncElement.dataset['showdots'] === 'true' || false,
                drag: this.syncElement.dataset['disabledrag'] === 'true' ? false : true,
                direction: this.direction,
                destroy: this.syncElement.dataset['enableondesktop'] == 'false' || false,
                padding: {
                    left: this.syncElement.dataset['desktoppaddingleft'] || 0,
                    right: this.syncElement.dataset['desktoppaddingright'] || 0,
                },
                omitEnd: this.syncElement.dataset['omitEnd'] == 'false' || false,
                breakpoints: {
                    750: {
                        perPage: this.syncElement.dataset['mobileperpage'] || 2,
                        padding: {
                            left: this.syncElement.dataset['mobilepaddingleft'] || 0,
                            right: this.syncElement.dataset['mobilepaddingright'] || 0,
                        },
                        gap: this.syncElement.dataset['gapbetweenslidesonmobile'] || 0,
                        destroy: this.syncElement.dataset['enableonmobile'] == 'false' || false,
                    }
                },
            });

            this.carousel.sync(this.carouselSync);
            this.initProgressBar(this.carouselSync);
            this.carouselSync.mount();
            this.carousel.mount();

            if (this.refresh) {
                this.carousel.refresh();
                this.carouselSync.refresh();
            }
        }
    }

    customElements.define("carousel-component", Carousel);
}
